import axios from 'axios'
import { TokenRegisterType } from './types'
import { StorageKeys } from '@/contexts/Auth/types'
import {
  handleLogoutEmbed,
  handleManyRequestsRefreshToken,
} from '@/utils/postMessages/handleLogoutEmbed'
import { applyAppTokenRefreshInterceptor } from '@conexasaude/apply-refresh-token'
import coreApi from './coreApi'
import { env } from '@/constants/env'
import { ConexaResponseError } from '@/types'

const auditTrackerApi = axios.create({
  baseURL: env.VITE_APP_AUDIT_TRACKER_URL,
})

export const tokenRegisterAuditTrackerApi: TokenRegisterType = token => {
  const interceptorId = auditTrackerApi.interceptors.request.use(config => {
    if (!config.headers.token) {
      config.headers.token = token
    }

    return config
  })

  return () => auditTrackerApi.interceptors.request.eject(interceptorId)
}

const handleRefreshToken = async () => {
  const refreshToken = localStorage.getItem(StorageKeys?.refreshToken)
  const userId = localStorage.getItem(StorageKeys?.userId)

  const { data } = await coreApi.post('token/refresh', {
    usuario_id: userId,
    refreshToken: refreshToken,
    audience: 'WEB',
  })

  return data?.accessToken
}

applyAppTokenRefreshInterceptor({
  client: auditTrackerApi,
  options: {
    shouldIntercept(error: ConexaResponseError) {
      return (
        error?.response?.status === 401 &&
        error?.response?.data?.msg?.includes('INVALID_ACCESS_TOKEN')
      )
    },
  },
  handleRefreshToken,
  onSuccess(accessToken) {
    tokenRegisterAuditTrackerApi(accessToken)
    localStorage.setItem(StorageKeys?.token, accessToken)
  },
  onError(error) {
    if (error?.response?.status === 429) {
      handleManyRequestsRefreshToken()
      return
    }

    if (error?.response?.status === 401) {
      console.log('handleRefreshToken error<>>', error)
      localStorage.clear()
      handleLogoutEmbed()
    }
  },
})

export default auditTrackerApi
